import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useAjaxContext } from "../../../core/ajax"
import { feedback } from '../../../core/feedback'

export const useNotificationsCalls = () => {
  const { get,post,putById,deleteById,getById } = useAjaxContext()
  const { formatMessage } = useIntl()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () =>
    feedback('error', formatMessage({ id: 'calls.default.error.description' }))

  const getAvisos = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        if (!config.params.updated) {
          get(`/avisos`, config)
            .then((response) => {
              resolve(response)
            })
            .catch(({ response }) => {
              if (!response) {
                noResponseError()
                return reject('No response')
              }
              switch (response.status) {
                default:
                  defaultError()
              }
              return reject(response.status)
            })
        }
      }
      ),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const getAvisosByUser = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get(`/avisos/by_user`, config)
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            /*switch (response.status) {
              default:
                defaultError()
            } */
            return reject(response.status)
          })
      }),
  [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const markAsRead = useCallback(
    (aviso_id) =>
      new Promise((resolve, reject) => {
        putById(`/avisos/check`,aviso_id,{})
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )



  return {
    getAvisos,
    getAvisosByUser,
    markAsRead
  }
}